import React from 'react'

import  { useNavigate } from 'react-router-dom'

import { Button, Card, CardMedia, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/system'

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#fffefe',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(12, 15),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 10)
    }
  },
  headerTxt: {
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: '2.5rem',
    '& span': {
      color: theme.palette.primary.main
    }
  }
}))

const data = [{
  title: <>Tadı damağınızda kalacak <span>Sandviçler</span></>,
  description: 'Birbirinden lezzetli sandviçlerle her ögününe renk kat! Bu çıtır çıtır bir rüya.',
  img: 'https://images.unsplash.com/photo-1509722747041-616f39b57569?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  imagePosition: 'right'
},
{
  title: <>En başarılı <span>Hamburgerciler</span></>,
  description: 'El yapımı köfteler, yumuşacık ekmekler daha neler neler… En nefis hamburgerler burada.',
  img: 'https://images.unsplash.com/photo-1561758033-d89a9ad46330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  imagePosition: 'left'
},
{
  title: <>Birbirinden leziz <span>Pizzalar</span></>,
  description: 'Tadına doyamayacağınız pizzaları doya doya tüketmeniz için yüksek biriktiren kumPara oranları burada',
  img: 'https://images.unsplash.com/photo-1595708684082-a173bb3a06c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1464&q=80',
  imagePosition: 'right'
}
]

export default function ThreeRowBanner () {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {
        data.map((item, index) => <RowCard key={index} {...item} />)
      }
    </div>
  )
}

const RowCard = ({ title, description, img, imagePosition }) => {
  const classes  = useStyles()
  const navigate = useNavigate()
  return (
    <Card sx={{
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      width: '80vw',
      marginTop: 8
    }} elevation={16}>
      <Box order={imagePosition === 'right' ? 0 : 1} sx={{
        width: {
          xs: '100%',
          md: '40%'
        },
        minHeight: {
          xs: 450,
          md: '100%'
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        paddingX: 3,
        paddingY: 6
      }}>
        <Typography component="div" variant="h5" className={classes.headerTxt}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.primary" component="div">
          {description}
        </Typography>

        <Button color='primary' variant='contained' sx={{ boxShadow: 'none', color: '#fff', fontWeight: 'bold' }} onClick={() => navigate('/login')} >Sipariş Ver  &gt;</Button>

      </Box>
      <CardMedia
        sx={{
          width: {
            xs: '100%',
            md: '60%'
          },
          maxHeight: 450
        }}
        component="img"

        image={img}
      />
    </Card>
  )
}
